var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 9a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0M16 16c-4.675 0-7.629 1.413-9.443 3.358-1.79 1.92-2.343 4.222-2.5 5.776C3.884 26.853 5.333 28 6.805 28h18.39c1.471 0 2.92-1.147 2.747-2.866-.156-1.554-.709-3.856-2.499-5.775-1.814-1.946-4.768-3.36-9.443-3.36m-9.953 9.335c.133-1.316.592-3.132 1.972-4.612C9.375 19.268 11.751 18 16 18c4.25 0 6.624 1.268 7.98 2.723 1.381 1.48 1.84 3.296 1.973 4.612a.52.52 0 0 1-.162.442.86.86 0 0 1-.596.223H6.805a.86.86 0 0 1-.597-.223.52.52 0 0 1-.161-.442",
    clipRule: "evenodd"
  })));
};
export default SvgProfile;